/* global axios */
import ApiClient from './ApiClient';

// Card-4.10 (2026-04-29) — admin CRUD para sequências de atividades.
// Backend: app/controllers/api/v1/accounts/pipeline/activity_sequences_controller.rb
//
// Wrapper completo para PipelineSequenceDefinition: index/show/create/update/
// destroy + activate/deactivate/duplicate (member actions).
class PipelineSequenceDefinitionsAPI extends ApiClient {
  constructor() {
    // Note: o controller fica em namespace 'pipeline/activity_sequences'.
    super('pipeline/activity_sequences', { accountScoped: true });
  }

  list({ active = null, page = 1, perPage = 25 } = {}) {
    const params = new URLSearchParams({ page, per_page: perPage });
    if (active !== null) params.append('active', active);
    return axios.get(`${this.url}?${params.toString()}`);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(
      this.url,
      { pipeline_activity_sequence: data },
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

  update(id, data) {
    return axios.patch(
      `${this.url}/${id}`,
      { pipeline_activity_sequence: data },
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  activate(id) {
    return axios.post(`${this.url}/${id}/activate`);
  }

  deactivate(id) {
    return axios.post(`${this.url}/${id}/deactivate`);
  }

  duplicate(id, newName = null) {
    const body = newName ? { name: newName } : {};
    return axios.post(`${this.url}/${id}/duplicate`, body);
  }
}

export default new PipelineSequenceDefinitionsAPI();
